<template>
  <div>
    <van-empty image="error" :description="description" />
  </div>
</template>

<script>
export default {
  name: 'PageError',
  props: {
    description: {
      type: String
    }
  }
}
</script>
